import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useStore } from '../../../store/index';
import { JobPostingProvider } from '../../../contexts/JobPostingContext';
import { pageLoadEvents } from '../../../utils/analytics';
import { HOME_PAGE_PATH } from '../../../utils/constants';
import { CreateJobPostingHeader } from '../../../components/JobPostings/CreateJobPostingContent/CreateJobPostingHeader';
import { CreateJobPostingBody } from '../../../components/JobPostings/CreateJobPostingContent/CreateJobPostingBody';
import { CreateJobProgress } from '../../../components/JobPostings/CreateJobPostingContent/CreateJobProgress';

const _CreateJobPostingPage = () => {

  const {
    authStore: {
      authorized,
      authInProgress
    }
  } = useStore();

  useEffect(() => {
    if (!authInProgress && !authorized) {
      window.location.replace(`${HOME_PAGE_PATH}`);
    } else {
      pageLoadEvents.createNewJobPosting();
    }
  }, []);

  return (
    <ErrorBoundary name="create-job-posting-page">
      <div data-testid="createJobPosting" className="create-job-posting">
        <JobPostingProvider>
          <ErrorBoundary name="create-job-posting-header">
            <CreateJobPostingHeader />
          </ErrorBoundary>
          <div className="create-job-posting__body-sections">
            <ErrorBoundary name="create-job-posting-body">
              <CreateJobPostingBody />
            </ErrorBoundary>
            <ErrorBoundary name="create-job-progress">
              <CreateJobProgress />
            </ErrorBoundary>
          </div>
        </JobPostingProvider>
      </div>
    </ErrorBoundary>
  );
};

export const CreateJobPostingPage = observer(_CreateJobPostingPage);
